import styled from 'styled-components';

import { size } from '../layout/helpers';
import { fontBold } from '../layout/font';

export const Wrapper = styled.div`
  position: relative;

  ${(props) => props.theme.breakpoint.Sm} {
    display: flex;
    align-items: center;
  }
`;

export const ImageWrapper = styled.div`
  width: ${size(14)};
  height: ${size(14)};

  ${(props) => props.theme.breakpoint.LtSm} {
    margin-bottom: ${size(2)};

    &:empty {
      display: none;
    }
  }

  ${(props) => props.theme.breakpoint.Sm} {
    flex-shrink: 0;
    margin-left: ${size(4)};
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
`;

export const ContentWrapper = styled.div`
  ${(props) => props.theme.breakpoint.Sm} {
    flex: 1 1 auto;
    order: -1;
  }
`;

export const Breadcrumb = styled.div`
  margin-bottom: ${size(1)};
  color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
  font-size: 0.875rem;
`;

export const Heading = styled.div`
  ${fontBold};
  font-size: 1.5rem;

  &[href] {
    text-decoration: none;
    color: currentColor;

    &:hover {
      text-decoration: underline;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const Preamble = styled.div`
  margin-top: ${size(2)};

  em {
    font-style: normal;
  }
`;
